import React from 'react';
import { Box, Center, Heading, Image, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import chargerImg from '../../../assets/images/evse_charger_inactive.svg';
import chargerStatusImg from '../../../assets/images/evse_charger_status_offline.svg';
import { ArcButton } from '../../../common/components/ArcButton';
import { SlidingAnimationPageBase } from '../../../common/components/SlidingAnimationPageBase';

type Props = {
  isDeviceRemoved?: boolean;
};

/* istanbul ignore next -- @preserve */
export const NoDevice = ({ isDeviceRemoved }: Props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <SlidingAnimationPageBase
      title={t('Common.device setup')}
      backURL={`../../../home`}
      customNavigationDirection="forward"
    >
      <Center flexDirection="column" px={3} textAlign="center">
        <Box data-testid="ev-image-container" position={'relative'}>
          <Image src={chargerStatusImg} alt="No Charging Station" mb={4} />
          <Image src={chargerImg} alt="Charging Station" position={'absolute'} right={84} bottom={70} />
        </Box>

        <Heading mt={2}>{isDeviceRemoved ? t('Set Up Hardware.charger removed') : t('EVSE.charger not found')}</Heading>
        <Text data-testid="ev-add-text" mt={1}>
          {t('Set Up Hardware.add new charger text')}
        </Text>

        <ArcButton
          data-testid="ev-charger-add"
          onClick={() => navigate(`../device-scan`)}
          mt={8}
          w={'80%'}
          arcColor="#3DCD57"
        >
          {t('Set Up Hardware.add charger')}
        </ArcButton>
      </Center>
    </SlidingAnimationPageBase>
  );
};
